<div class="offline-report-preview" [style]="reportContentStyle" (click)="onClick()">
  <div *ngIf="isReady" [style]="reportPreviewStyle" id="pageScroll" (scroll)="scrollEvent($event)">
    <app-report-page-container-offline #reportPages *ngFor="let pageKey of reportPageKeys; index as i"
      [id]="'offline-preview-' + i"
      [pageKey]="pageKey" [style]="0 < i ? reportPageOuterStyle : reportPageOuterFirstStyle"
      [isLastPage]="i >= reportPageKeys.length - 1">
    </app-report-page-container-offline>
  </div>
</div>
